import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CurrencyDetailsResponse } from "../../helpers/models/CurrencyDetailsModel";
import { getCurrencyList } from "../../services/CurrencyService";

const initialState = {
  isCurrencyListLoading: false,
  currencyList: [],
  selectedCurrency: null
};

export const getCurrencyListThunk = createAsyncThunk(
  "jobPricing/currencyData",
  async (payload: any, thunkApi) => {
    try {
      return await getCurrencyList();
    } catch (error) {
      return thunkApi.rejectWithValue({ error });
    }
  }
);

export const currencyDetailsSlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    resetCurrencyState: () => initialState,
    setCurrencyDetails: (state, action) => {
      state.currencyList = action.payload;
    },
    setSelectedCurrency: (state, action) => {
      state.selectedCurrency = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrencyListThunk.pending, (state, action) => {});
    builder.addCase(getCurrencyListThunk.fulfilled, (state: any, action) => {
      const response: CurrencyDetailsResponse = action.payload.data;
      state.currencyList = response.data || [];
    });
    builder.addCase(getCurrencyListThunk.rejected, (state, action) => {
      state.currencyList = [];
    });
  }
});

export const { resetCurrencyState, setCurrencyDetails, setSelectedCurrency } =
  currencyDetailsSlice.actions;

export default currencyDetailsSlice.reducer;
